import { useState, useEffect } from 'react';
import { SimpleGrid, Card, Text, Title, Group, Badge, Loader, Center, Stack } from '@mantine/core';
import { IconUsers, IconBook, IconCheckbox, IconDatabase } from '@tabler/icons-react';
import { api } from '../../apiClient';

/**
 * 管理画面のダッシュボード
 * 資格数・問題数・ユーザー数などのサマリーを表示する
 */
function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const stats = await api.get('/stats');
        setStats(stats);
      } catch (err) {
        console.error('統計情報の取得に失敗しました:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <Center h={200}>
        <Loader size="sm" />
      </Center>
    );
  }

  // サマリーカードの定義
  const cards = [
    {
      title: '資格数',
      value: stats?.totalCerts ?? 0,
      icon: <IconBook size={24} />,
      color: 'blue',
      sub: `AWS: ${stats?.awsCerts}  Microsoft: ${stats?.microsoftCerts}`,
    },
    {
      title: '問題数',
      value: stats?.totalQuestions?.toLocaleString() ?? 0,
      icon: <IconCheckbox size={24} />,
      color: 'teal',
      sub: '全資格合計',
    },
    {
      title: 'ロール付与済みユーザー数',
      value: stats?.totalUsers ?? 0,
      icon: <IconUsers size={24} />,
      color: 'violet',
      sub: 'editor / admin を持つユーザー',
    },
    {
      title: 'スクレイプジョブ数',
      value: stats?.totalJobs ?? 0,
      icon: <IconDatabase size={24} />,
      color: 'orange',
      sub: stats?.runningJobs > 0
        ? `実行中: ${stats.runningJobs}`
        : '実行中のジョブなし',
    },
  ];

  return (
    <Stack gap="lg">
      <Title order={3}>ダッシュボード</Title>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing="md">
        {cards.map((card) => (
          <Card key={card.title} withBorder shadow="sm" radius="md" p="lg">
            <Group justify="space-between" mb="xs">
              <Text fw={500} size="sm" c="dimmed">{card.title}</Text>
              <Badge color={card.color} variant="light" size="sm">
                {card.icon}
              </Badge>
            </Group>
            <Text fw={700} size="xl">{card.value}</Text>
            <Text size="xs" c="dimmed" mt={4}>{card.sub}</Text>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}

export default AdminDashboard;
